export default function currency(value) {
  const stringValue = parseFloat(value)
  if (Number.isNaN(stringValue)) {
    return ''
  }
  return `${stringValue.toFixed(2).replace('.', ',')}€`
}
